import styled from 'styled-components'
import { breakpoints, Margin } from '@spritz-finance/ui'

export const ContentContainer = styled.div`
    padding ${Margin.Small};
    padding-top: 0;
    width: 528px;
    ${breakpoints.xsmall} {
        width: unset;
    }  
`
